import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  getDocs,
  orderBy,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { NewUserProfileType } from "../Types/userProfile";
import MyConnectionsPost from "./MyConnectionsPost";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";
import styles from "./Connection.module.css";

import { getStorage, ref } from "firebase/storage";

const db = getFirestore(app);

//Query and get all user profiles in an array except this user
//Query and get this user's profile
//Run through this user's profile's userConnections array one at a time
//  Using the userConnections email entry run through the userProfiles's entries looking for a match
//    If a match copy the entire entry into a tempArray
//Return the tempArray
const tempUser = localStorage.getItem("userUID");

console.log("this user id = ", tempUser);
//query all userProfile and output only this user

function MyConnectionsPre() {
  const [userProfilesAll, setUserProfilesAll] = useState<NewUserProfileType[]>(
    []
  );
  const [thisUserProfile, setThisUserProfile] = useState<NewUserProfileType[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(true); // New: track loading state

  let temp = "";
  //if (thisUserProfile[0].userConnections.length === 0) {
  //  setIsLoading(false); // Done loading regardless of result
  //}
  const qUser = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  //load only this user's profile
  useEffect(
    () =>
      onSnapshot(qUser, (snapshot) => {
        setThisUserProfile(
          snapshot.docs.map((doc) => {
            if (doc.data().userConnections.length === 0) {
              setIsLoading(false);
            }
            //console.log(
            //  "doc.data().userConnections = ",
            //  doc.data().userConnections.length
            //);
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //query all userProfile but do not include this user
  const qUsersAll = query(
    collection(db, "userProfiles"),
    where("userUID", "!=", tempUser),
    orderBy("userProfileName", "desc")
  );

  useEffect(
    () =>
      onSnapshot(qUsersAll, (snapshot) => {
        setUserProfilesAll(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //Create a temp user profile array
  let userProfiles = [];
  let i = 0,
    j = 0,
    k = 0;

  console.log("length of userProfilesAll = ", userProfilesAll.length);
  console.log(" thisUserProfile.length", thisUserProfile.length);
  //console.log(" thisUserProfile", thisUserProfile);
  console.log(" thisUserProfile[0]", thisUserProfile[0]);
  if (userProfilesAll.length != 0 && thisUserProfile.length != 0) {
    for (i = 0; i < thisUserProfile[0].userConnections.length; i++) {
      console.log(
        "i = ",
        i,
        " thisUserProfile[0].userConnections[i] = ",
        thisUserProfile[0].userConnections[i]
      );
      for (k = 0; k < userProfilesAll.length; k++) {
        //console.log("k = ", k, " and userConnections = ", userProfilesAll[i].userConnections[k]);
        if (
          userProfilesAll[k].userEmail === thisUserProfile[0].userConnections[i]
        ) {
          userProfiles[j] = userProfilesAll[k];
          j++;
          //console.log(" userConnectionsOK = 0 ");
        }
      }
    }
  }
  //console.log("userProfiles.length = ", userProfiles.length);

  if (
    !isLoading &&
    thisUserProfile[0].userConnections.length === 0 &&
    userProfiles.length === 0
  ) {
    return (
      <div>
        <h3 style={{ marginLeft: 50, marginTop: 40, marginBottom: -20 }}>
          &nbsp; No records found
        </h3>
        <button
          style={{ marginLeft: 250, marginTop: -60 }}
          className={styles.userButtons}
          onClick={() => history.back()}
        >
          Return
        </button>
      </div>
    );
  } else if (userProfiles.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {userProfiles.map((userProfiles) => (
        <MyConnectionsPost key={userProfiles.id} userProfile={userProfiles} />
      ))}
    </div>
  );
}

export default MyConnectionsPre;
